module.exports = __webpack_public_path__ + "d6d54988f18be0584d16836941da40e4.pdf";